import { createTheme } from "@mantine/core";

export const theme = createTheme({
  primaryColor: "green",
  primaryShade: { light: 7, dark: 6 },

  fontFamily: "Inter, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
  fontFamilyMonospace: "JetBrains Mono, monospace",

  headings: {
    fontFamily: "Inter, system-ui, sans-serif",
    fontWeight: "700",
    sizes: {
      h1: {
        fontSize: "clamp(36px, 4vw, 48px)",
        lineHeight: "1.2",
        fontWeight: "800",
      },
      h2: { fontSize: "clamp(28px, 3vw, 36px)", lineHeight: "1.25" },
      h3: { fontSize: "24px", lineHeight: "1.3", fontWeight: "600" },
      h4: { fontSize: "20px", lineHeight: "1.4", fontWeight: "600" },
    },
  },

  defaultRadius: "lg",

  breakpoints: {
    xs: "36em",
    sm: "48em",
    md: "62em",
    lg: "64em",
    xl: "88em",
  },

  spacing: {
    xs: "8px",
    sm: "12px",
    md: "16px",
    lg: "24px",
    xl: "32px",
  },

  shadows: {
    sm: "0 1px 3px rgba(0, 0, 0, 0.05)",
    md: "0 4px 12px rgba(0, 0, 0, 0.08)",
    lg: "0 12px 32px rgba(0, 0, 0, 0.10)",
    xl: "0 24px 64px rgba(43, 138, 62, 0.15)",
  },

  components: {
    Button: {
      defaultProps: {
        radius: "lg",
      },
      styles: {
        root: {
          fontWeight: 600,
          letterSpacing: "-0.01em",
        },
      },
    },
    Container: {
      defaultProps: {
        size: "lg",
      },
    },
  },
});
